// client/src/coms/components/comslayout_parts/comsSession.js
const COMS_SESSION_PREFIX = 'voxemera';

function readComsSessionJson(key, fallback = null) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return fallback;
    const raw = window.localStorage.getItem(`${COMS_SESSION_PREFIX}:${key}`);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : fallback;
  } catch {
    return fallback;
  }
}

function writeComsSessionJson(key, value) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.setItem(`${COMS_SESSION_PREFIX}:${key}`, JSON.stringify(value));
  } catch {}
}

function normalizePersistedTab(value) {
  const tab = value != null ? String(value).trim() : '';
  if (tab === 'social') return 'social';
  if (tab === 'watch') return 'watch';
  if (tab === 'canvas') return 'canvas';
  if (tab === 'games') return 'games';
  if (tab === 'studio') return 'studio';
  if (tab === 'maps') return 'maps';
  if (tab === 'marketplace') return 'marketplace';
  if (tab === 'settings') return 'settings';
  if (tab === 'chats') return 'chats';
  return 'coms';
}

function normalizePersistedSocialSection(value) {
  const section = value != null ? String(value).trim().toLowerCase() : '';
  if (section === 'pending') return 'pending';
  if (section === 'dms') return 'dms';
  return 'friends';
}

export function removeComsSessionKey(key) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.removeItem(`${COMS_SESSION_PREFIX}:${key}`);
  } catch {}
}

export function getPersistedLastLocation() {
  const v = readComsSessionJson('lastLocation', null);
  if (!v) return null;
  const serverId = v.serverId != null ? String(v.serverId).trim() : '';
  const channelId = v.channelId != null ? String(v.channelId).trim() : '';
  return serverId || channelId ? { serverId, channelId } : null;
}

export function setPersistedLastLocation(serverId, channelId) {
  const sid = serverId != null ? String(serverId).trim() : '';
  const cid = channelId != null ? String(channelId).trim() : '';
  if (!sid && !cid) {
    removeComsSessionKey('lastLocation');
    return;
  }
  writeComsSessionJson('lastLocation', { serverId: sid, channelId: cid, ts: Date.now() });
}

export function getPersistedVoiceResume() {
  const v = readComsSessionJson('lastVoiceSession', null);
  if (!v || !v.wasConnected) return null;
  const serverId = v.serverId != null ? String(v.serverId).trim() : '';
  const channelId = v.channelId != null ? String(v.channelId).trim() : '';
  const channelDbId = v.channelDbId != null ? String(v.channelDbId).trim() : '';
  if (!serverId || !channelId || !channelDbId) return null;
  return { serverId, channelId, channelDbId };
}

export function setPersistedVoiceResume({ serverId, channelId, channelDbId, wasConnected }) {
  if (!wasConnected) {
    removeComsSessionKey('lastVoiceSession');
    return;
  }
  const sid = serverId != null ? String(serverId).trim() : '';
  const cid = channelId != null ? String(channelId).trim() : '';
  const cdb = channelDbId != null ? String(channelDbId).trim() : '';
  if (!sid || !cid || !cdb) {
    removeComsSessionKey('lastVoiceSession');
    return;
  }
  writeComsSessionJson('lastVoiceSession', {
    wasConnected: true,
    serverId: sid,
    channelId: cid,
    channelDbId: cdb,
    ts: Date.now(),
  });
}

export function getPersistedComsNav() {
  const v = readComsSessionJson('comsNav', null);
  if (!v) {
    return {
      activeTab: 'coms',
      socialSection: 'friends',
      selectedSocialThreadId: '',
    };
  }

  return {
    activeTab: normalizePersistedTab(v.activeTab),
    socialSection: normalizePersistedSocialSection(v.socialSection),
    selectedSocialThreadId: v.selectedSocialThreadId != null ? String(v.selectedSocialThreadId).trim() : '',
  };
}

export function setPersistedComsNav({ activeTab, socialSection, selectedSocialThreadId }) {
  const next = {
    activeTab: normalizePersistedTab(activeTab),
    socialSection: normalizePersistedSocialSection(socialSection),
    selectedSocialThreadId: selectedSocialThreadId != null ? String(selectedSocialThreadId).trim() : '',
    ts: Date.now(),
  };

  writeComsSessionJson('comsNav', next);
}